import { Controller } from '@hotwired/stimulus'

interface TurboBeforeRenderDetail {
  render: (currElement: Element, newElement: Element) => void
}

export default class extends Controller {
  static values = { url: String }
  declare urlValue: string

  connect(): void {
    if (this.supportsViewTransitions) {
      document.addEventListener('turbo:before-render', this.transition, { once: true })
    }
    Turbo.visit(this.urlValue)
  }

  // Wrap only this navigation's render in a view transition, so the crossfade is
  // scoped to the post-autofill redirect instead of every same-origin v2 nav.
  // The render function performs a synchronous DOM swap, so old/new snapshots are
  // captured correctly around it.
  private transition = (event: Event): void => {
    const detail = (event as CustomEvent<TurboBeforeRenderDetail>).detail
    const originalRender = detail.render
    detail.render = (currElement, newElement) => {
      document.startViewTransition(() => {
        originalRender(currElement, newElement)
      })
    }
  }

  private get supportsViewTransitions(): boolean {
    return document.startViewTransition !== undefined
  }
}
